class Datalayer {
  private _event: string
  private _property: Record<string, unknown>

  constructor(event: string, property: Record<string, unknown>) {
    this._event = event
    this._property = property
  }

  get property(): Record<string, unknown> {
    return this._property
  }

  set property(value: Record<string, unknown>) {
    this._property = value
  }
  get event(): string {
    return this._event
  }
  set event(value: string) {
    this._event = value
  }
}

export default Datalayer
